import { z } from 'zod';

export const ApiErrorDataSchema = z
  .object({
    response: z
      .object({
        data: z
          .object({
            message: z.string().optional(),
            slug: z.string().optional(),
          })
          .passthrough(),
      })
      .passthrough(),
  })
  .transform(({ response: { data } }) => data);

export const getApiErrorData = (
  error: unknown,
): { message?: string; slug?: string } => {
  const parsedError = ApiErrorDataSchema.safeParse(error);
  return parsedError.success ? parsedError.data : {};
};
